module.exports = __webpack_public_path__ + "img/03.b7b5b485.png";